module.exports = __webpack_public_path__ + "img/chengyun4.ecd4c1f6.png";